import React from 'react';
import { Divider, ListItem, ListItemText } from '@material-ui/core';
import { Tag, TagType, Size } from '@signaturit/react-components-library';

import { Trans } from 'react-i18next';
import i18next from 'i18next';

import { useSideNavigationMenuItemStyles } from './SideNavigationMenuItem.styles';
import { SideNavigationMenuSubItems } from '../SideNavigationMenuSubItems/SideNavigationMenuSubItems';
import { ASSETS_PATH } from '../../../../../../main/constants/endpoints';
import { ISideNavigationMenuItemsConfig } from '../../SideNavigationMenuConfiguration';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export interface ISideNavigationMenuItemProps {
    item: ISideNavigationMenuItemsConfig;
    isSelected: boolean;
    expandedMenu: ISideNavigationMenuItemsConfig | null;
    selectedSubMenu: ISideNavigationMenuItemsConfig | null;
    onClick: (item: ISideNavigationMenuItemsConfig) => void;
    onSubMenuItemClick: (item: ISideNavigationMenuItemsConfig) => void;
    isSendboard: boolean;
}

export const SideNavigationMenuItem = ({
    item,
    isSelected,
    onClick,
    onSubMenuItemClick,
    expandedMenu,
    selectedSubMenu,
    isSendboard,
}: ISideNavigationMenuItemProps) => {
    const classes = useSideNavigationMenuItemStyles();
    const iconBasePath = `${ASSETS_PATH}/img/menu/`;
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const showSubMenus = hasSubItems && !isSendboard;

    return (
        <div className={showSubMenus && expandedMenu === item ? classes.container : ''}>
            <ListItem
                data-signa={'sidebar-item'}
                classes={{
                    root: classes.menuListItem,
                    selected: showSubMenus ? classes.menuListItemMultiSelected : classes.menuListItemSelected,
                }}
                button={true}
                disableRipple={true}
                selected={isSelected}
                onClick={() => onClick(item)}
            >
                {item.icon && (
                    <img
                        className={isSelected ? classes.listIconSelected : classes.listIcon}
                        src={`${iconBasePath}${item.icon}.svg`}
                    />
                )}

                <ListItemText
                    primaryTypographyProps={{
                        variant: 'body2',
                    }}
                    classes={{
                        primary: isSelected ? classes.menuListItemContentSelected : classes.menuListItemContent,
                    }}
                >
                    <Trans>{i18next.t(item.name)}</Trans>
                    {item.showTag && (
                        <div className={classes.menuListItemTag}>
                            <Tag type={TagType.marketing} size={Size.small}>
                                {i18next.t('default.menus._left.new')}
                            </Tag>
                        </div>
                    )}
                </ListItemText>
                {hasSubItems && (
                    <ArrowDropDownIcon
                        fontSize={Size.small}
                        classes={{ root: isSelected ? classes.caretSelected : classes.caret }}
                    ></ArrowDropDownIcon>
                )}
            </ListItem>
            {showSubMenus && (
                <SideNavigationMenuSubItems
                    items={item.subItems}
                    isOpened={expandedMenu === item}
                    selectedSubMenu={selectedSubMenu}
                    onClick={onSubMenuItemClick}
                ></SideNavigationMenuSubItems>
            )}
            {item.withDivider && <Divider className={classes.divider} />}
        </div>
    );
};
